export const SWIFT_ORDER_SIGNATURE_VERIFICATION_ERROR_MESSAGE =
	'Signature did not verify';

export const LEDGER_SIGN_OFF_CHAIN_MESSAGE_ERROR_MESSAGE =
	'Signature did not verify. If you are using a Ledger hardware wallet, disable Gasless Trading in Settings.';
